import React from "react";

import PageWrapper from "../components/PageWrapper";
import HowWeWorkHero from "../sections/how-we-work/HowWeWorkHero";
import PhaseDetail from "../sections/how-we-work/PhaseDetail";
import WhatWeTouch from "../sections/how-we-work/WhatWeTouch";
import Cadence from "../sections/how-we-work/Cadence";
import WhatWeDontDo from "../sections/how-we-work/WhatWeDontDo";
import CTA from "../sections/landing4/CTA";
import Seo from "../components/Seo";

const HowWeWorkPage = () => (
  <>
    <Seo
      title="How We Work — Audit, Build, Operate"
      description="Three phases: one-week infra audit, three-month senior embed, optional long-term junior staffing. No retainer commitment until you've seen the audit."
      pathname="/how-we-work"
      image="/images/og-how.png"
    />
    <PageWrapper>
      <HowWeWorkHero />
      <PhaseDetail />
      <WhatWeTouch />
      <Cadence />
      <WhatWeDontDo />
      <CTA />
    </PageWrapper>
  </>
);

export default HowWeWorkPage;
